import { ElementType, FC } from "react";
import styled from "styled-components";
import { position, PositionProps, variant } from "styled-system";
import css from "@styled-system/css";

import Box from "../Box/Box";
import { BoxProps } from "../Box/box.type";
import variants from "./variants";

export interface CountProps extends BoxProps, PositionProps {
  /**
   Available variants: "default" | "active"
   */
  variant?: "default" | "active";
  /**
   A number to be displayed
   */
  number: number;
  /**
   The html tag to be used
   */
  as?: ElementType;
  /**
   Allows the user to specify any custom styles.
  */
  css?: string;
}

const StyledCount = styled(Box)<CountProps>`
  ${position}
  ${css({
    borderRadius: 1,
    lineHeight: "normal",
    fontWeight: "normal",
    fontSize: "body",
  })}
  ${variant({ variants })}
  ${(props) => props.css}
`;

const Count: FC<CountProps> = ({
  variant = "default",
  number,
  as = "span",
  ...props
}) => {
  const formatedNumber = number?.toLocaleString("en-GB", {
    maximumFractionDigits: 0,
  });

  return (
    <StyledCount as={as} variant={variant} p={1} width="fit-content" {...props}>
      {formatedNumber}
    </StyledCount>
  );
};

export default Count;
